import { useRef, useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import {
    Link
} from "react-router-dom";

import { 
	GetLocal
} from "../../../Base/BaseControl";

export default function Index(props) {
    
	useEffect(() => {
        document.querySelectorAll('.nav-item a').forEach((el, i) => {
            //if (i != 0) {
                if (el.getAttribute('href').split('?')[0] == window.location.pathname) {
                    el.parentNode.querySelector('a').style.backgroundColor = "#585858";
                }
            //}
        });
		
        document.querySelectorAll('.nav-item a').forEach((el, i) => {
            el.addEventListener('click', (e) => {
				toast.dismiss();
                document.querySelectorAll('.nav-item a').forEach((el, i) => {
                    el.style.backgroundColor = "#212529";
                });				
                el.parentNode.querySelector('a').style.backgroundColor = "#585858";
            });
        });	
    }, []);		

    return (
        <ul class="mynav nav nav-pills flex-column mb-auto p-0">
            <li class="nav-item mb-1">
                <Link to={'/Trade/ShowBusinessToll?page=مشاهده عوارض کسب و پیشه'}>
                    <i class="fa fa-industry text-warning"></i>
                    مشاهده عوارض کسب و پیشه
                </Link>
            </li>
        </ul>
    );
}
